export const Header = {
  baseStyle: {
    position: 'relative',
    padding: '64px 0',
    margin: '0 auto',
    textAlign: 'center',
    fontSize: '48px',
    fontWeight: '300',
    color: 'brand.white',
    objectFit: 'fill',
    overflow: 'hidden',
  },
};
